<template>
  <div class="fl border-box h-95p" :style="'width:' + width" >
    <div class="bor-deep-gra bg-wh h-100p ovf-auto">
      <p class="p-t-20 p-b-20 p-l-20 m-t-0 m-b-0 bor-b-gray fw-b">配置项</p>
      <div class="p-t-20 p-l-30">
        <div v-if="curInput.default && !curInput.default.type">请选择控件</div>
        <common-config :curInput="curInput" :inputList="inputList" :showName="showName" v-if="curInput.default && curInput.default.type"></common-config>
        <text-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_INPUTTEXT"></text-config>
        <password-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_PASSWORD"></password-config>
        <textarea-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_TEXTAREA"></textarea-config>
        <radio-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_RADIO"></radio-config>
        <checkbox-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_CHECKBOX"></checkbox-config>
        <select-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_SELECT"></select-config>
        <date-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_DATE"></date-config>
        <datetime-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_BOTH_DATE_TIME"></datetime-config>
        <time-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_TIME"></time-config>
        <file-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_FILE"></file-config>
        <editor-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_EDITOR"></editor-config>
        <struct-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_STRUCT"></struct-config>
        <people-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_PERSON"></people-config>
        <foreignkey-config :curInput="curInput" :inputList="inputList" v-if="curInput.default && curInput.default.type == TYPE_FOREIGNKEY"></foreignkey-config>
        <cascader-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_CASCADER"></cascader-config>
        <subform-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_SUBFORM"></subform-config>
        <userInfo-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_USER"></userInfo-config>
        <dealtime-config :curInput="curInput" v-if="curInput.default && curInput.default.type == TYPE_DEALTIME"></dealtime-config>
      </div>
    </div>
  </div>
</template>

<style>
  .form-tips {
    font-size: 12px;
  }
  .form-tips:before {
    display: inline-block;
    color: #ff4949;
    margin-right: 4px;
    content: '*';
  }
</style>

<script>
  import modelConfig from '../../../config/modelConfig'
  import commonConfig from '../../Model/configComponents/commonConfig'
  import textConfig from '../../Model/configComponents/textConfig'
  import passwordConfig from '../../Model/configComponents/passwordConfig'
  import textareaConfig from '../../Model/configComponents/textareaConfig'
  import radioConfig from '../../Model/configComponents/radioConfig'
  import checkboxConfig from '../../Model/configComponents/checkboxConfig'
  import selectConfig from '../../Model/configComponents/selectConfig'
  import dateConfig from '../../Model/configComponents/dateConfig'
  import datetimeConfig from '../../Model/configComponents/datetimeConfig'
  import timeConfig from '../../Model/configComponents/timeConfig'
  import editorConfig from '../../Model/configComponents/editorConfig'
  import fileConfig from '../../Model/configComponents/fileConfig'
  import structConfig from '../../Model/configComponents/structConfig'
  import peopleConfig from '../../Model/configComponents/peopleConfig'
  import foreignkeyConfig from '../../Model/configComponents/foreignkeyConfig'
  import cascaderConfig from '../../Model/configComponents/cascaderConfig'
  import subformConfig from '../../Model/configComponents/subformConfig'
  import userInfoConfig from '../../Model/configComponents/userInfoConfig'
  import dealtimeConfig from '../../Model/configComponents/dealtimeConfig'
  export default {
    props: ['curInput', 'inputList', 'width', 'showName'],
    data() {
      return {
      }
    },
    mixins: [modelConfig],
    components: {
      commonConfig,
      textConfig,
      passwordConfig,
      textareaConfig,
      radioConfig,
      checkboxConfig,
      selectConfig,
      dateConfig,
      datetimeConfig,
      timeConfig,
      fileConfig,
      editorConfig,
      structConfig,
      peopleConfig,
      foreignkeyConfig,
      cascaderConfig,
      subformConfig,
      userInfoConfig,
      dealtimeConfig
    },
    created() {
    },
    methods: {
    }
  }
</script>


// WEBPACK FOOTER //
// inputConfig.vue?637494c8